import React from "react";
import AppRemitocReactTable from "../table/AppRemitocReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Remitocs = () => {
  return (
    <>
      <AppRemitocReactTable />
      {/* <TableRemitocs /> */}
      <Footer />
    </>
  );
};

export default Remitocs;
